import React from "react";
import { FiSearch } from "react-icons/fi";

const MENUS = [
  { value: "header", label: "Menu principal / Header" },
  { value: "footer", label: "Menu pied de page / Footer" },
  { value: "secondaire", label: "Menu secondaire" },
];

const LOCALES = [{ value: "fr", label: "Français" }];

const fieldClass =
  "w-full rounded-2xl border border-slate-300 bg-white px-4 py-2.5 text-sm text-slate-900 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-sky-950";

export default function FiltersBar({
  menuKey,
  onMenuKey,
  locale,
  onLocale,
  includeInactive,
  onIncludeInactive,
  q,
  onQ,
  onSubmit,
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      className="grid gap-3 xl:grid-cols-[260px_150px_minmax(280px,1fr)_auto] xl:items-end"
    >
      <Field label="Menu à organiser">
        <select
          value={menuKey}
          onChange={(e) => onMenuKey(e.target.value)}
          className={fieldClass}
        >
          {MENUS.map((menu) => (
            <option key={menu.value} value={menu.value}>
              {menu.label}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Langue">
        <select
          value={locale}
          onChange={(e) => onLocale(e.target.value)}
          className={fieldClass}
        >
          {LOCALES.map((localeItem) => (
            <option key={localeItem.value} value={localeItem.value}>
              {localeItem.label}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Rechercher">
        <div className="relative">
          <FiSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            value={q}
            onChange={(e) => onQ(e.target.value)}
            placeholder="Nom du menu, page, URL…"
            className={`${fieldClass} pl-11`}
          />
        </div>
      </Field>

      <label className="flex min-h-[43px] items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm font-medium text-slate-700 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-200">
        <input
          type="checkbox"
          checked={includeInactive}
          onChange={(e) => onIncludeInactive(e.target.checked)}
          className="rounded border-slate-300"
        />
        Voir les éléments inactifs
      </label>
    </form>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
        {label}
      </span>
      {children}
    </label>
  );
}